import React, { ReactElement } from 'react';
import { css } from '@emotion/react';
import { BsStopwatch } from '@react-icons/all-files/bs/BsStopwatch';
import { CgMathPercent } from '@react-icons/all-files/cg/CgMathPercent';
import {
  NumberInputField,
  SelectField,
  ToggleField,
} from '@bucketplace/commerce-admin-ui';

import {
  FormContent,
  InspectorFormProvider,
} from '../../components';
import { DocumentInspectorProps } from '../../types';
import { CarouselProps } from './Carousel';

const ALIGN_OPTIONS = [
  {
    text: '중앙',
    value: 'center',
  },
  {
    text: '왼쪽',
    value: 'left',
  },
];

export function CarouselInspector({
  value,
  onChange,
}: DocumentInspectorProps<CarouselProps>): ReactElement {
  return (
    <InspectorFormProvider value={value} onChange={onChange}>
      <FormContent header="자동재생">
        <ToggleField name="autoPlay" />
      </FormContent>
      { value.props.autoPlay && (
        <FormContent header="자동재생 인터벌">
          <NumberInputField
            name="autoPlayInterval"
            label={<BsStopwatch />}
            placeholder="0"
            direction="HORIZONTAL"
            width="100%"
            customCss={css`
              > div {
                width: 100%;
              }
            `}
          />
        </FormContent>
      ) }
      <FormContent header="루프">
        <ToggleField name="loop" />
      </FormContent>
      <FormContent header="아이템 너비">
        <NumberInputField
          name="childWidthPercentage"
          label={<CgMathPercent />}
          direction="HORIZONTAL"
          width="100%"
          customCss={css`
            > div {
              width: 100%;
            }
          `}
        />
      </FormContent>
      <FormContent header="아이템 정렬">
        <SelectField
          name="align"
          options={ALIGN_OPTIONS}
          width="100%"
        />
      </FormContent>
      <FormContent header="페이지네이션">
        <ToggleField name="hasPagination" />
      </FormContent>
      <FormContent header="화살표">
        <ToggleField name="hasArrow" />
      </FormContent>
    </InspectorFormProvider>
  );
}
